module.exports = __webpack_public_path__ + "static/media/todano220.1893ee66.pdf";